import React from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { FaPlus } from 'react-icons/fa'
import { useMutation, useClient } from 'jsonapi-react'

import { Albums } from 'components/Albums'
import { ActionButton, Body, ActionButtonsGroup } from 'layouts/basic'
import Modal from 'components/Modal'
import Input from 'components/Forms/Input'
import Button from 'components/Button'
import useAuthStore from 'store/auth'


export default function BaseSceneAlbum(props) {
  const [showModalNewAlbum, setShowModalNewAlbum] = React.useState(false)
  const [isFetchingSearch, setIsFetchingSearch] = React.useState(false)
  const [hasMore, setHasMore] = React.useState(true)
  const [albums, setAlbums] = React.useState([])
  const [isFetching, setIsFetching] = React.useState(false)

  const client = useClient()
  const { isLogged } = useAuthStore()
  const [addAlbum] = useMutation(['albums'])

  const { s } = useParams()
  const history = useHistory()

  const page = React.useRef(0)
  const filters = React.useRef({})
  const timeout = React.useRef(null)

  const inputRef = React.useRef(null)

  if (s !== '') {
    filters.current = {
      'filter[search]': s,
    }
  }

  React.useEffect(() => {
    setAlbums([])
    page.current = 0
    loadMore()
  }, [s]) // eslint-disable-line

  const onSubmit = async e => {
    e.preventDefault()
    const result = await addAlbum({
      title: e.currentTarget.elements[0].value,
    })

    if (result.error) {
      alert(result.error.detail)
      return

    } else {
      history.push(`/albums/${result.data.id}`)

    }
  }

  const loadMore = async () => {
    if (isFetching) return

    setIsFetching(true)

    page.current = page.current + 1

    const { data, error } = await client.fetch([
      ...props.query,
      {
        include: 'created_by,thumbnail',
        'fields[Album]': 'title,permissions,created_by,thumbnail,created_at',
        'fields[User]': 'full_name',
        'fields[File]': 'file,title,type,thumbnail,small,medium',
        'page[number]': page.current,
        'sort': '-createdAt',
        ...filters.current,
      },
    ])

    if (!error) {
      setAlbums(albums => ([
        ...albums,
        ...data,
      ]))
      setHasMore(true)

    } else {
      setHasMore(false)

    }
    setIsFetching(false)
    setIsFetchingSearch(false)

  }

  const onChange = async e => {
    setIsFetchingSearch(true)
    const value = e.currentTarget.value

    if (timeout.current)
      clearTimeout(timeout.current)

    timeout.current = setTimeout(() => {
      if (value !== '') {
        history.push(`${props.baseRedirect}/s/${value}`)

      } else {
        history.push(props.baseRedirectEmpty || props.baseRedirect)

      }
    }, 800)

  }

  return (
    <>
      {props.headers}
      <div className='p-10'>
        <div className='max-w-2xl mx-auto'>
          <Input
            loading={isFetchingSearch}
            onChange={onChange}
            className='mb-0'
            inputProps={{
              placeholder: 'Search...',
              defaultValue: s,
            }}
          />
        </div>
      </div>
      <Body noPadding className='px-10' loading={!!(props.loading || (isFetching && albums.length === 0))}>
        <Modal
          active={!!showModalNewAlbum}
          onClose={() => setShowModalNewAlbum(false)}
          className='p-5 sm:p-2'
        >
          <Modal.Content>
            <div className='prose-sm sm:prose-lg'>
              <h2>Create new album</h2>
              <form onSubmit={onSubmit}>
                <Input
                  focusAuto
                  ref={inputRef}
                  inputProps={{
                    name: 'title',
                    placeholder: 'Title',
                  }}
                />
                <Button type='submit'>Save</Button>
              </form>
            </div>
          </Modal.Content>
        </Modal>
        <Albums
          loading={isFetching}
          items={albums}
          loadMore={loadMore}
          hasMore={hasMore}
        />
        {
          isLogged &&
          <ActionButtonsGroup>
            <ActionButton
              onClick={() => setShowModalNewAlbum(true)}
            >
              <FaPlus />
            </ActionButton>
          </ActionButtonsGroup>
        }
      </Body>
    </>
  )
}
